import { INewbuildingPromo } from '@cian/frontend-newbuilding-promo-carousel-component';

import { IGetNewbuildingsForBuildersPromoResponse } from 'shared/repositories/newbuilding-search/entities/get_newbuildings_for_builders_promo_slider/GetNewbuildingsForBuildersPromoResponse';

import { INewbuildingsForPromoSliderResponse } from '../types/newbuildingsForPromoSlider';

export const transformNewbuildingsForPromoSlider = (
  response: IGetNewbuildingsForBuildersPromoResponse,
): INewbuildingsForPromoSliderResponse => {
  return {
    newbuildings: response.newbuildings.map(
      (newbuilding): INewbuildingPromo => ({
        address: newbuilding.address,
        id: newbuilding.id,
        imageUrl: newbuilding.imageUrl,
        isLoaded: true,
        minPrice: newbuilding.minPrice,
        name: newbuilding.name,
        statusDisplay: newbuilding.statusDisplay,
        undergroundInfo: newbuilding.undergroundInfo,
        url: newbuilding.url,
      }),
    ),
  };
};
